import { render, staticRenderFns } from "./ViewToken.vue?vue&type=template&id=9710a7d2&lang=pug&"
import script from "./ViewToken.vue?vue&type=script&lang=js&"
export * from "./ViewToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports